import { render, staticRenderFns } from "./ItemViewTable.vue?vue&type=template&id=19f02d44&scoped=true&"
import script from "./ItemViewTable.vue?vue&type=script&lang=js&"
export * from "./ItemViewTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19f02d44",
  null
  
)

export default component.exports